export default __webpack_public_path__ + "static/media/Path 20.99400d68.svg";